<script>
export default {
  props: {
    newsId: {
      type: String,
      required: true
    }
  },
  computed: {
    index () {
      function indexOf (array, key, value) {
        if (!Array.isArray(array)) {
          return false
        }
        for (let i = 0; i < array.length; i++) {
          if (array[i][key] === value) {
            return i
          }
        }
        return false
      }
      return indexOf(this.list, 'id', this.newsId)
    },
    list () {
      return this.docs.news
    },
    news () {
      return this.list[this.index]
    },
    next () {
      const item = this.list[this.index - 1]
      return item ? item.id : false
    },
    prev () {
      const item = this.list[this.index + 1]
      return item ? item.id : false
    }
  },
  mounted () {
    // IE11判定 IEだと記事中リンクのroute変更を検出できなかったため
    const agent = window.navigator.userAgent.toLowerCase()
    if ((agent.indexOf('trident/7') !== -1)) {
      const a = document.querySelector('a.video')
      const hash = a.href.match(/#\d+$/)[0]
      a.href = '/movie' + hash
    }
  }
}
</script>

<template>
  <div class="gp-news-article transition-item">
    <article class="news-article">
      <header>
        <time class="date is-family-oswald">{{ news.date }}</time>
        <h1 class="title is-size-2 is-size-4-mobile">
          <span>{{ news.title }}</span>
        </h1>
      </header>
      <div class="text is-size-4 is-size-5-mobile" v-html="news.text"></div>
    </article>
    <nav>
      <div class="level is-mobile is-size-2 has-text-weight-bold is-family-oswald">
        <div :class="{disable: !next}">
          <router-link :to="{name: 'news-article', params: {newsId: next}}">
            <span :class="{link: next}">PREV</span>
          </router-link>
        </div>
        <div>
          <router-link :to="{name: 'news'}">
            <span class="link">LIST</span>
          </router-link>
        </div>
        <div :class="{disable: !prev}">
          <router-link :to="{name: 'news-article', params: {newsId: prev}}">
            <span :class="{link: prev}">NEXT</span>
          </router-link>
        </div>
      </div>
    </nav>
  </div>
</template>

<style lang="scss" scoped>
.gp-news-article {
  text-align: start;
  @include is-not-mobile {
    width: 100%;
  }
  .news-article {
    @include is-mobile {
      padding: 1rem 1.5rem;
    }
    @include is-not-mobile {
      margin-bottom: 3rem;
    }
    .date {
      background-color: $white;
      padding: .25rem .5rem;
      display: inline-block;
    }
    .title span {
      background-color: $black;
      color: $orange;
      padding: .25rem .5rem;
      @include is-mobile {
        display: block;
      }
    }
    .text {
      margin: 1.5rem 0;
      @include is-mobile {
        line-height: 24px;
      }
      @include is-not-mobile {
        line-height: 28px;
      }
    }
  }
  nav {
    width: 18rem;
    margin: auto;
    .current .link,
    .link:hover {
      color: $orange;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/news/news-article.vue